import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleMoveListElement(task: Identifiable<Task>): Identifiable<Task> {
  return task;
}

export { handleMoveListElement };
